<template>
  <div class="ascii">
    <img src="/other/max.jpeg"/>
    <p>
        {{ascii}}
    </p>
  </div>
</template>
<script>
export default {
  name: 'Ascii',
  data () {
    return {
      ascii: `
            @@@@@@@@@%&%%&&&@&&&&&@@&&(%#%%&&@&&&&&@@&@@@@&&%%@&@@@@@&&&&@@@&@&&%&%@@@&&%&@@
            %%&@&#/(&&@@&&&&&%%#%&@@&#/#&&&&@@@@@@&@@&%%&&&&&&&@@@@@@&%&%#&&%&@%%&&&@@@@@@@@
            %%&&&&#(/%&@&@@@@&%%&&&&&//*/&&&%##/#(&&&&&@/(%&&&@@@@@%#%%%%%%%&%%%&&&###&@@@@@
            ###&&&&#/#&&@@@@@@&##&@%(###%%%&&##((///(/***,*,/(//**%%&&&&@@@@@@&&@&&&&&@@@@&&
            /(&#((#%/**((&(*//&&#((/(#/(((//((*%(**,,,*,*,,**/,,*/(/(&&@&&@@@@@@@@@@@@@@@&&&
            ##/*.*(%#*#/#(*(/#&@@%(//#*(&&%%####%%&&%%(#(#&%#(#/***/((/@@@&&@@&@@@@@@&&&&%%&
            #&#((((,(///,//*///%%#,,(*((#%&&&&&@&&@@@@@&%&%&###(((//*/(/&(((#%&@@@&%&@@@@@@@
            (*/(/((,*//**///****,**/*(((((/(((#(((###%#%&&&%###%%#(/(##//%&&&%&@@&@@@@@@@@&&
            /#****/#(/,*,,**,/*,//*(#%%%%#((/*.........,**/(##%%&&%%%((//(&@@@@&&@@@@&&&&@&&
            /((*,,,,,,*,*/,.,*/((%%%%&&%%(/**...............,,,*****(%%##(&@@@@@&&&@&#%&&@@@
            ,**(/*/*****///***/#%&&&&&&%%#//*,,.......................*%#(%&&&&&&@&%%@@@@@@@
            //((/*****/**,/////#%&&&&%&&&#(/*,,,.......... ............###%@#((#(#%%%##&@@&&
            ///*,*/(/*/,,...*#%&@@&@&&#%%#/*,,,,,,,,,,,.,..............###%&&&@@@@&&@&@@@&&%
            /(((#(**/**,*,*(%&&@@&&@@&%%/,,..,///(#%&&&&%#(/*,,,,,,,,..%%%&@&&&@@@@@@@@@@&&&
            (#((##(/,/**/(#((&&((*#&&%#/,...,*/(##///(###(/***(#&&@&&##%%&@@@@@@@@@&&&&@@&%&
            (#(##(//*,/*,,,**&,(,*((#%%/,......,**/(/////**. .#&@@&/(//##%%%%&&@@&%%%&@@&&&%
            ((##%%%%/(/*/((//#,,*/(/*/(,.,........,,,,,,,.... .#(////**@@&&@@@@@@&&&&&@@@@@&
            (#(***,,.,,,,,*,*#,*.,*,*,***,,,,................. ,..,....(*/#&@@&@&&&((#&@@@@@
            *//((%%#&%#((///*%%/...,,*(/**,,,.......,,,/.........,...../(&&&#%////(%@@@@@@&@
            %&%%%%%#((#(/((***%&@&//#,(/**,,*,,,*,,,**,(#&@%(((/**,,..*(/,.*////%@@&@@@&@@&%
            &&%%%&&%&%%((/((*//#&@//**#///*,*,,,,**,*,,,*/(##(*,*/***,//(#(//(#(//(/(@@&&&&&
            #%&&%####((#%#***(&&&&@&&&##(///*****/(&####((/**//,/****/*((/#&%&&%#(**(///&@@&
            %(/*/#*,(((((***##/**&&&&@@&&%((////*/*,********,,,,***(%&&%#//(/,%%&&#%%((/,*#%
            ***,,##(((/#((//((/(%#((/@&@@&@&&#///,*****((###(/**//(%@@&%%((((%#//(%&&#(%(((/
            ,***(%#*///*//(%#/#(/%&&###/@@@@@@@&#/*,,,,,.,,,,,,*/%&&@@@@&&##&@@@&&#%%((%%%&%
            #(*,.*(/,(#%&%((#%%%%%%&&@&%(#%@@@@@@@@&*****,,***/#&&@&&&&&@&#//&@&&@&%##%%#%&&
            //,*/*,(#((#**//((#%@%%%%%%@&(/(&@@@@@@@@@@&%%###%%@@@@%%@&%&@&%(%@&@&&@%&&&@&%%
            **/*////*,**(/#((/(#%%&&&&&&@((/((%&@@@@@@@@@@@@@&&@@@@&%/*#%%&%(#&@&&&&@@@@@@@&
            &%%*****,(/*/////%%#%##%&@&&&@&%(/((&@@@@@@@@@@@@@@@@@@@@&(((/#%#(#%&@@&&&&&&@@@
            **,*(//*,,(**////#(#&%%%%&&@@@@@&&&%((&@@@@@@@@@@@@@@@@@@&//((#%##%(%%&@@@@@@@@@
            ****/*///**(///(/((((#%@&&&%&&@@@@@@@@%&#@@@@@@@@@@@@@@@@%&%##%&%#(#%###&&&@@%#%
            *//*//(/((/(*///(((((#%#&&&&@&@&&@@@@@@@@@@@@@@@@@@@@@@@/**%(#%##%&@&###%&%%&@&&
        `
    }
  }
}
</script>

<style lang="scss">
.ascii {
    user-select: none;
    display: grid;
    width: 80%;
    min-height: 352px;
    font-size: 0.7rem;
    transition: 1s;
    padding: 0px 10px;
    img {
      opacity: 0;
      grid-column: 1;
      grid-row: 1;
      height: 352px;
      width: 343px;
      z-index: 2;
      margin: 10px 0px 10px 0px;
      transition: 0.25s;
      &:active {
        opacity: 1;
      }
    }
    p {
      margin: 10px 0px;
      grid-column: 1;
      grid-row: 1;
      z-index: 1;
    }
    }
</style>
